__turbopack_context__.v({
  "dropdown": "menu-module__unbnHa__dropdown",
  "item": "menu-module__unbnHa__item",
  "itemLabel": "menu-module__unbnHa__itemLabel",
});
